import global from './GlobalStore';

export default class AudioStore {
  constructor() {
    this.audio = {};
  }

  setAudio(audio) {
    this.audio = audio;
  }

  getAudio() {
    return this.audio;
  }

  createClipp(file = {}, user = {}) {
    return global()
      .getApi()
      .audioApi.createClipp(file.name, file.type, file.size, user.id)
      .then(result => {
        if (result && result.status === 200 && result.payload) {
          this.setAudio(result.payload.audio);
          this.uploadAudio(file, result.payload.url);
        }
      });
  }

  deleteClipp(clippId = '', user = {}) {
    return global()
      .getApi()
      .audioApi.deleteClipp(clippId, user.id)
      .then(result => {
        if (result && result.status === 200 && result.payload) {
          console.log(result);
        }
      });
  }

  uploadAudio(file, oneTimeUrl) {
    return global()
      .getApi()
      .audioApi.uploadAudioFile(file, oneTimeUrl)
      .then(result => {
        if (result) {
          console.log(result);
        }
      });
  }

  loadAudio(audioId, audioType, callback) {
    return global()
      .getApi()
      .audioApi.loadAudioFile(audioId, audioType)
      .then(result => {
        if (result && result.status === 200 && result.payload && result.payload.audio) {
          callback(result.payload.audio);
        }
      });
  }
}
